// Utility function for selecting an HTMLElement node
// Perform the same functionality as (Document | Element).querySelector, but return null if the found element doesn't extend from HTMLElement
// - return (HTMLElement | null) instead of (Node | null)
export const queryHtmlElement = (root: Document | Element, selector: string): HTMLElement | null => {
    const el = root.querySelector(selector);
    return el instanceof HTMLElement ? el : null;
};
